// Property Cashflow For Life's progress device, the 5 Ms pentagon (reference/pcfl-v3/source/app.jsx,
// Pentagon), in the hub's tokens. Each side is a module: solid once its homework is all ticked,
// dashed for the module they're up to, unlit otherwise. With labels it names each side (Home); small,
// it's the mark beside a module's heading and on a thumbnail. Colours come from ondemand.css.
//
//   <Pentagon states={['done', 'current', 'todo', 'todo', 'todo']} labels names={[...5 titles]} />
//   <Pentagon states={...} size={34} />          small, no labels
//   <Pentagon states={...} size={44} dark />     on the dark thumbnail
const CX = 100
const CY = 100

function corners(r) {
  return [0, 1, 2, 3, 4].map(i => {
    const a = ((-90 + 72 * i) * Math.PI) / 180
    return [CX + r * Math.cos(a), CY + r * Math.sin(a)]
  })
}

export function Pentagon({ states, labels = false, names = [], size = null, dark = false, title = null }) {
  const r = labels ? 70 : 62
  const v = corners(r)
  const box = labels ? '-92 14 384 188' : '30 30 140 132'
  const sw = labels ? 7 : 13
  const cls = `od-pent${dark ? ' od-pent--dark' : ''}${labels ? ' od-pent--labels' : ''}`
  const style = size ? { width: size } : undefined
  return (
    <svg className={cls} viewBox={box} style={style} role={title ? 'img' : undefined} aria-label={title || undefined}
      aria-hidden={title ? undefined : 'true'} overflow="visible">
      <polygon className="od-pent-base" points={v.map(p => p.join(',')).join(' ')} strokeWidth={sw} />
      {v.map((p, i) => {
        const q = v[(i + 1) % 5]
        const s = states[i] || 'todo'
        if (s === 'todo') return null
        return (
          <line key={i} className={`od-pent-side od-pent-side--${s}`} x1={p[0]} y1={p[1]} x2={q[0]} y2={q[1]} strokeWidth={sw}
            strokeDasharray={s === 'current' && labels ? '10 9' : undefined} />
        )
      })}
      {labels && v.map((p, i) => {
        const q = v[(i + 1) % 5]
        const mx = (p[0] + q[0]) / 2, my = (p[1] + q[1]) / 2
        const dx = mx - CX, dy = my - CY, len = Math.hypot(dx, dy)
        const x = mx + (dx / len) * 16
        const y = my + (dy / len) * 16 + (dy / len > 0.9 ? 15 : 5)
        const anchor = x > CX + 5 ? 'start' : x < CX - 5 ? 'end' : 'middle'
        const s = states[i] || 'todo'
        return <text key={`t${i}`} className={`od-pent-label od-pent-label--${s}`} x={x} y={y} textAnchor={anchor}>{names[i] || ''}</text>
      })}
    </svg>
  )
}

// The small mark for 1 module: only its own side, lit when its homework is done, dashed while
// they're on it. Only where the course has the 5 Ms (pentagon: Property Cashflow For Life's own, by
// its slug, courseModel's pentagon); another on-demand course's module has no mark (the review of 13 Oct:
// a sixth module drew a pentagon with no side lit)
export function ModuleMark({ index, state, size = 34, dark = false, pentagon = true }) {
  if (!pentagon) return null
  const states = [0, 1, 2, 3, 4].map(i => (i === index ? (state === 'todo' ? 'current' : state) : 'todo'))
  return <Pentagon states={states} size={size} dark={dark} />
}
